import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '../views/login/Login.vue'
import request from '@/common/request'
import store from '@/store'

Vue.use(VueRouter)

const verificaAutenticacao = async (to, from, next) => {
  if (store.getters.usuarioEstaLogado) {
    try {
      await request.get('/auth/validaToken')
      return next()
    } catch (error) {
      return next('/login')
    }
  }
  next('/login')
}

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    name: 'Application',
    component: () => import('../views/Application.vue'),
    beforeEnter: verificaAutenticacao,
    children: [
      {
        path: 'home',
        name: 'Home',
        components: {
          default: () => import('../views/Home.vue')
        }
      },
      {
        path: 'tipo-icms',
        name: 'TelaDeTipoICMS',
        components: {
          default: () => import('../views/cadastros/tipoicms/TelaDeTipoICMS.vue'),
          toolbar: () => import('../components/layout/ApplicationTopBar.vue')
        },
        props: {
          toolbar: () => ({ titulo: 'Tipos ICMS' })
        }
      },
      {
        path: 'fornecedores',
        name: 'TelaDeFornecedor',
        components: {
          default: () => import('../views/cadastros/fornecedor/TelaDeFornecedor.vue'),
          toolbar: () => import('../components/layout/ApplicationTopBar.vue')
        },
        props: {
          toolbar: () => ({ titulo: 'Fornecedores' })
        }
      },
      {
        path: 'empresas',
        name: 'TelaDeEmpresa',
        components: {
          default: () => import('../views/cadastros/empresa/TelaDeEmpresa.vue'),
          toolbar: () => import('../components/layout/ApplicationTopBar.vue')
        },
        props: {
          toolbar: () => ({ titulo: 'Empresas' })
        }
      },
      {
        path: 'lei',
        name: 'TelaDeLei',
        components: {
          default: () => import('../views/cadastros/lei/TelaDeLei.vue'),
          toolbar: () => import('../components/layout/ApplicationTopBar.vue')
        },
        props: {
          toolbar: () => ({ titulo: 'Leis' })
        }
      },
      {
        path: 'cfop',
        name: 'TelaDeCFOP',
        components: {
          default: () => import('../views/cadastros/cfop/TelaDeCFOP.vue'),
          toolbar: () => import('../components/layout/ApplicationTopBar.vue')
        },
        props: {
          toolbar: () => ({ titulo: 'CFOPs' })
        }
      },
      {
        path: 'ncm',
        name: 'TelaDeNCM',
        components: {
          default: () => import('../views/cadastros/ncm/TelaDeNCM.vue'),
          toolbar: () => import('../components/layout/ApplicationTopBar.vue')
        },
        props: {
          toolbar: () => ({ titulo: 'NCMs' })
        }
      },
      {
        path: 'segmento',
        name: 'TelaDeSegmento',
        components: {
          default: () => import('../views/cadastros/segmento/TelaDeSegmento.vue'),
          toolbar: () => import('../components/layout/ApplicationTopBar.vue')
        },
        props: {
          toolbar: () => ({ titulo: 'Segmentos' })
        }
      },
      {
        path: 'cest',
        name: 'TelaDeCEST',
        components: {
          default: () => import('../views/cadastros/cest/TelaDeCEST.vue'),
          toolbar: () => import('../components/layout/ApplicationTopBar.vue')
        },
        props: {
          toolbar: () => ({ titulo: 'CESTs' })
        }
      },
      {
        path: 'cst',
        name: 'TelaDeCST',
        components: {
          default: () => import('../views/cadastros/cst/TelaDeCST.vue'),
          toolbar: () => import('../components/layout/ApplicationTopBar.vue')
        },
        props: {
          toolbar: () => ({ titulo: 'CSTs' })
        }
      },
      {
        path: 'nesh',
        name: 'TelaDeNESH',
        components: {
          default: () => import('../views/cadastros/nesh/TelaDeNESH.vue'),
          toolbar: () => import('../components/layout/ApplicationTopBar.vue')
        },
        props: {
          toolbar: () => ({ titulo: 'NESHs' })
        }
      },
      {
        path: 'natureza',
        name: 'TelaDeNatureza',
        components: {
          default: () => import('../views/cadastros/natureza/TelaDeNatureza.vue'),
          toolbar: () => import('../components/layout/ApplicationTopBar.vue')
        },
        props: {
          toolbar: () => ({ titulo: 'Naturezas' })
        }
      },
      {
        path: 'icms',
        name: 'TelaDeICMS',
        components: {
          default: () => import('../views/cadastros/icms/TelaDeICMS.vue'),
          toolbar: () => import('../components/layout/ApplicationTopBar.vue')
        },
        props: {
          toolbar: () => ({ titulo: 'ICMS' })
        }
      },
      {
        path: 'piscofins',
        name: 'TelaDePISCOFINS',
        components: {
          default: () => import('../views/cadastros/piscofins/TelaDePISCOFINS.vue'),
          toolbar: () => import('../components/layout/ApplicationTopBar.vue')
        },
        props: {
          toolbar: () => ({ titulo: 'PIS COFINS' })
        }
      },
      {
        path: 'itensVO',
        name: 'TelaDeItensVO',
        components: {
          default: () => import('../views/cadastros/itensVO/TelaDeItensVO.vue'),
          toolbar: () => import('../components/layout/ApplicationTopBar.vue')
        },
        props: {
          toolbar: () => ({ titulo: 'Itens VO' })
        }
      },
      {
        path: 'ipi',
        name: 'TelaDeIPI',
        components: {
          default: () => import('../views/cadastros/ipi/TelaDeIPI.vue'),
          toolbar: () => import('../components/layout/ApplicationTopBar.vue')
        },
        props: {
          toolbar: () => ({ titulo: 'IPIs' })
        }
      },
      {
        path: 'usuarios',
        name: 'TelaDeUsuarios',
        components: {
          default: () => import('../views/usuarios/TelaDeUsuarios.vue'),
          toolbar: () => import('../components/layout/ApplicationTopBar.vue')
        },
        props: {
          toolbar: () => ({ titulo: 'Usuários' })
        }
      },
      {
        path: 'perfis',
        name: 'TelaDePerfis',
        components: {
          default: () => import('../views/perfis/TelaDePerfis.vue'),
          toolbar: () => import('../components/layout/ApplicationTopBar.vue')
        },
        props: {
          toolbar: () => ({ titulo: 'Perfis' })
        }
      },
      {
        path: 'permissoes',
        name: 'TelaDePermissoes',
        components: {
          default: () => import('../views/permissoes/TelaDePermissoes.vue'),
          toolbar: () => import('../components/layout/ApplicationTopBar.vue')
        },
        props: {
          toolbar: () => ({ titulo: 'Permissões' })
        }
      },
      {
        path: 'atualizacoes',
        name: 'TelaDeAtualizacoes',
        components: {
          default: () => import('../views/atualizacoes/TelaDeAtualizacoes.vue'),
          toolbar: () => import('../components/layout/ApplicationTopBar.vue')
        },
        props: {
          toolbar: () => ({ titulo: 'Atualizações' })
        }
      },
      {
        path: 'entradas',
        name: 'TelaDeEntradas',
        components: {
          default: () => import('../views/atualizacoes/TelaDeEntradas.vue'),
          toolbar: () => import('../components/layout/ApplicationTopBar.vue')
        },
        props: {
          toolbar: (route) => {
            let atualizacao
            if (route.params.atualizacao) atualizacao = route.params.atualizacao
            else atualizacao = JSON.parse(route.query.atualizacao)

            return {
              titulo: `Entradas - Atualização ${atualizacao?.codigo} ~ ${atualizacao.empresa.nome} `,
              permiteVoltar: true
            }
          }
        },
        beforeEnter: (to, from, next) => {
          if (to.query.atualizacao) return next()
          if (from.name !== 'TelaDeAtualizacoes') return next('/atualizacoes')
          return next()
        }
      },
      {
        path: 'saidas',
        name: 'TelaDeSaidas',
        components: {
          default: () => import('../views/atualizacoes/TelaDeSaidas.vue'),
          toolbar: () => import('../components/layout/ApplicationTopBar.vue')
        },
        props: {
          toolbar: (route) => {
            let atualizacao
            if (route.params.atualizacao) atualizacao = route.params.atualizacao
            else atualizacao = JSON.parse(route.query.atualizacao)

            return {
              titulo: `Saídas - Atualização ${atualizacao?.codigo} ~ ${atualizacao.empresa.nome} `,
              permiteVoltar: true
            }
          }
        },
        beforeEnter: (to, from, next) => {
          if (to.query.atualizacao) return next()
          if (from.name !== 'TelaDeAtualizacoes') return next('/atualizacoes')
          return next()
        }
      },
      {
        path: 'nfes',
        name: 'TelaDeNFes',
        components: {
          default: () => import('../views/nfes/TelaDeNFes.vue'),
          toolbar: () => import('../components/layout/ApplicationTopBar.vue')
        },
        props: {
          toolbar: () => ({ titulo: 'NFes' })
        }
      },
      {
        path: 'itensCliente',
        name: 'TelaDeItensCliente',
        components: {
          default: () => import('../views/atualizacoes/TelaDeItensCliente.vue'),
          toolbar: () => import('../components/layout/ApplicationTopBar.vue')
        },
        props: {
          toolbar: () => ({ titulo: 'Itens do Cliente' })
        }
      },
      {
        path: 'tributacao',
        name: 'TelaDeTributacao',
        components: {
          default: () => import('../views/tributacoes/TelaDeTributacao.vue'),
          toolbar: () => import('../components/layout/ApplicationTopBar.vue')
        },
        props: {
          toolbar: () => ({ titulo: 'Tributação' })
        }
      },
      {
        path: 'vinculadorItens',
        name: 'TelaDeVinculoItens',
        components: {
          default: () => import('../views/atualizacoes/TelaDeVinculoItens.vue'),
          toolbar: () => import('../components/layout/ApplicationTopBar.vue')
        },
        props: {
          toolbar: () => ({ titulo: 'Vinculador' })
        }
      },
      {
        path: '*',
        redirect: '/home'
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
